import { createSelector } from 'reselect';
const organizationsStateSelector = ({ entities: { organizations } = {} }) =>
  organizations;

export const getOrganization = createSelector(
  [organizationsStateSelector, (_, { id }) => id],
  (organizations, id) => {
    return (organizations || {})[id];
  }
);

export const getOrgWithMemberStatus = createSelector(
  [getOrganization],
  organization => {
    const { membershipDetails: { type, statusType } = {} } = organization || {};

    return {
      ...organization,
      isMember:
        (type === 'Member' || type === 'Associate') && statusType === 'Active',
    };
  }
);



// WEBPACK FOOTER //
// ./src/redux-modules/organizations/selectors/index.js